export const BATCH_STATUS_OPEN = 'Open';
export const BATCH_STATUS_QUEUED = 'Queued';
export const BATCH_STATUS_PROCESSING = 'Processing';
export const BATCH_STATUS_GENERATING = 'Generating';
export const BATCH_STATUS_COMPLETED = 'Completed';
export const BATCH_STATUS_ARCHIVED = 'Archived';
export const BATCH_STATUS_NOTIFYING_MARKETPLACE = 'NotifyingMarketplace';
export const BATCH_STATUS_SENDING_EMAILS = 'SendingEmails';
export const BATCH_STATUS_INVALID = 'Invalid';
